/**
 * @owner @Appboy/whats-app
 * WhatsApp Message GET Schema
 *
 * This is a flat object schema containing all possible WhatsApp message fields
 * (both template and response). Required for z.discriminatedUnion compatibility.
 *
 * For type narrowing based on whats_app_message_type, use:
 * - whatsAppTemplateMessageGetSchema (whats_app_message_type = "template")
 * - whatsAppResponseMessageGetSchema (whats_app_message_type = "response")
 */

import { z } from "zod";
import { whatsAppTemplateMessageGetSchema } from "@schemas/message/whatsAppTemplateMessageGetSchema";
import { whatsAppResponseMessageGetSchema } from "@schemas/message/whatsAppResponseMessageGetSchema";
import { whatsAppEmptyMessageGetSchema } from "@schemas/message/whatsAppEmptyMessageGetSchema";

export const whatsAppMessageGetSchema = z.discriminatedUnion("whats_app_message_type", [
  whatsAppTemplateMessageGetSchema,
  whatsAppResponseMessageGetSchema,
  whatsAppEmptyMessageGetSchema,
]);
